import { Box, Button, TextField } from "@mui/material";
import { Send } from "@mui/icons-material";
import { palette } from "../../theme";

export const ChatInput = ({
  input,
  setInput,
  handleSendMessage,
}: {
  input: string;
  setInput: (input: string) => void;
  handleSendMessage: () => void;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: palette.gray_extra_light,
        border: `1px solid ${palette.gray_light}`,
        padding: "12px 16px",
        width: "100%",
        borderRadius: "20px",
        display: "flex",
        alignItems: "center",
        gap: 1,
        transition: "all 0.2s ease",
        "&:focus-within": {
          boxShadow: `0 0 0 2px ${palette.purple_light}`,
          borderColor: palette.purple,
        },
      }}
    >
      <TextField
        fullWidth
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
        placeholder="כתוב הודעה..."
        variant="standard"
        InputProps={{
          disableUnderline: true,
          sx: {
            fontSize: "0.95rem",
            "&::placeholder": {
              color: palette.gray,
              opacity: 0.7,
            },
          },
        }}
      />
      <Button
        onClick={handleSendMessage}
        disabled={!input.trim()}
        sx={{
          color: input.trim() ? palette.purple : palette.gray_light,
          minWidth: "40px",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: palette.purple_light,
            transform: "scale(1.05)",
          },
          "&:disabled": {
            backgroundColor: "transparent",
            transform: "none",
          },
        }}
      >
        <Send sx={{ transform: "rotate(180deg)" }} />
      </Button>
    </Box>
  );
};
